// extracted by mini-css-extract-plugin
export default {"ticketError":"IdmTickets_ticketError__I+qoI","idmTicketContainer":"IdmTickets_idmTicketContainer__1dJFW"};